import { actions } from 'react-redux-form';
import Moment from 'moment';
import { batch } from "react-redux";
import { httpGet, httpPost } from "../../../../utils/api.utils";
import { TRANSLATIONS, STRING_VALUES } from '../../../../utils/constant.utils';
import { convertStringBoolToBoolean } from '../../../../utils/helpers.utils'
import {
    getGlCodeStatusDropdown
    , glCodeDetailsFormModel
    , getGlCodeDetailsForm
} from "../../../../constants/model-reducers/external/finance/glcode-details/gl-code-details.settings"

export const glCodeDetailsFormState = glCodeDetailsFormModel;

const defaultState = () => ({
    glCodeStatusOptions: []
    , fetchFormInProgress: true
});


const initialState = defaultState();

export const glCodeDetailsActions = {
    getGlCodeDetailsForm: (glCodeId) => async (dispatch) => {
        var glCodeStatus = await getGlCodeStatus();

        var result = await httpGet(`external/finance/getGlCodeDetails/${glCodeId}`);
        var data = result.data;

        if (data) {
            batch(() => {
                dispatch({ type: getGlCodeStatusDropdown, data: glCodeStatus })

                dispatch(actions.load('glCodeDetailsForm.glCodeId', data.GlCodeId))
                dispatch(actions.load('glCodeDetailsForm.glCode', data.GlCode))
                dispatch(actions.load('glCodeDetailsForm.glCodeName', data.GlCodeName))
                dispatch(actions.load('glCodeDetailsForm.description', data.GlCodeDescription))
                dispatch(actions.load('glCodeDetailsForm.status', data.Status))
                dispatch(actions.load('glCodeDetailsForm.validFromDate', data.ValidFromDate ? new Date(data.ValidFromDate) : ''))
                dispatch(actions.load('glCodeDetailsForm.validToDate', data.ValidToDate ? new Date(data.ValidToDate) : ''))

                dispatch({ type: getGlCodeDetailsForm, data: false });
            });
            return data;
        }
        else {
            dispatch(actions.load("glCodeDetailsForm", glCodeDetailsFormState));
            dispatch(actions.reset('glCodeDetailsForm'));
        }
    },

    saveGlCodeDetails: (glCodeId, validate) => async (dispatch, state) => {
        let locale = state().translation.locale;
        if (locale === null || locale === '')
            locale = TRANSLATIONS['defaultLocaleLanguage'];

        try {
            const { glCodeDetailsForm } = state().form
            const { glCodeId, glCode, glCodeName, description, status, validFromDate, validToDate } = glCodeDetailsForm;

            var data = {
                GlCodeId: glCodeId
                , GlCode: glCode
                , GlCodeName: glCodeName
                , Description: description
                , Status: status !== STRING_VALUES.stringZero && status !== STRING_VALUES.stringNull ?
                    convertStringBoolToBoolean(status) : null
                , ValidFromDate: validFromDate ? Moment(validFromDate).toISOString(true) : null
                , ValidToDate: validToDate ? Moment(validToDate).toISOString(true) : null
            };

            var result = await saveGlCode(glCodeId, validate, data);

            if (result.success && validate == false) {
                batch(() => {
                    dispatch(actions.load("glCodeDetailsForm", glCodeDetailsForm));
                });
            }

            return result;
        }
        catch (e) {
            return e;
        }

    },

    getGlCodeStatusDropdown: () => async (dispatch, state) => {
        const { glCodeDetailsForm } = state().form
        var data = await getGlCodeStatus();

        if (glCodeDetailsForm.glCodeId == 0) {
            dispatch({ type: getGlCodeStatusDropdown, data: data });
            dispatch({ type: getGlCodeDetailsForm, data: false });
        } else {
            dispatch({ type: getGlCodeStatusDropdown, data: data });
        }
       
    },

    resetGlCodeDetailsForm: () => (dispatch) => {
        batch(() => {
            dispatch(actions.change('glCodeDetailsForm.glCodeId', glCodeDetailsFormModel.GlCodeId))
            dispatch(actions.change('glCodeDetailsForm.glCode', glCodeDetailsFormModel.GlCode))
            dispatch(actions.change('glCodeDetailsForm.glCodeName', glCodeDetailsFormModel.GlCodeName))
            dispatch(actions.change('glCodeDetailsForm.description', glCodeDetailsFormModel.GlCodeDescription))
            dispatch(actions.change('glCodeDetailsForm.status', glCodeDetailsFormModel.Status))
            dispatch(actions.change('glCodeDetailsForm.validFromDate', glCodeDetailsFormModel.ValidFromDate))
            dispatch(actions.change('glCodeDetailsForm.validToDate', glCodeDetailsFormModel.ValidToDate))
            dispatch(actions.reset('glCodeDetailsForm'));
        });
    },

    resetNewGlCodeForm: () => (dispatch) => {
        dispatch({ type: getGlCodeDetailsForm, data: true });
        dispatch(actions.reset('glCodeDetailsForm.glCodeId', glCodeDetailsFormModel.GlCodeId))
        dispatch(actions.load("glCodeDetailsForm", glCodeDetailsFormState));
        dispatch(actions.reset('glCodeDetailsForm'));
        
    }
}

async function saveGlCode(glCodeId, validate, data) {
    try {
        var result = await httpPost(`external/finance/saveGlCode/${glCodeId ?? 0}/${validate ?? 0}`, data);

        if (result.ok == false) {
            throw {
                success: false,
                message: "GL Code is not saved.Error encountered while on saving."
            }
        }
        return result;
    }
    catch (e) {
        throw e;
    }
}

async function getGlCodeStatus() {
    try {
        var result = await httpGet('external/finance/glcode-status-dropdown');

        return result.data;
    }
    catch (e) {
        return [];
    }
}


export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getGlCodeStatusDropdown:
            return {
                ...state,
                glCodeStatusOptions: action.data
            };
        case getGlCodeDetailsForm: {
            return {
                ...state,
                fetchFormInProgress: action.data
            };
        }
        default:
            return state;
    }
}